import { computed, inject, Injectable, signal } from '@angular/core';
import { OnboardingService } from '../../../services/onboarding.service';
import { OnboardingWorkflow } from '../../../interfaces/onboarding.interface';
import { IRondleidingStap, RONDLEIDINGEN } from './rondleidingen';

interface ILopendeRondleiding {
  workflow: OnboardingWorkflow;
  stappen: IRondleidingStap[];
  index: number;
}

/**
 * Welke rondleiding er loopt en bij welke stap. Het tekenen (spotlight en
 * ballon) doet RondleidingComponent, die in de ingelogde schil staat en dus
 * blijft staan als een stap naar een andere pagina gaat.
 */
@Injectable({
  providedIn: 'root'
})
export class RondleidingService {
  private readonly onboarding = inject(OnboardingService);

  private readonly lopend = signal<ILopendeRondleiding | null>(null);

  public readonly actief = computed(() => this.lopend() !== null);
  public readonly workflow = computed(() => this.lopend()?.workflow ?? null);
  public readonly index = computed(() => this.lopend()?.index ?? 0);
  public readonly aantal = computed(() => this.lopend()?.stappen.length ?? 0);
  public readonly stap = computed<IRondleidingStap | null>(() => {
    const r = this.lopend();
    return r ? r.stappen[r.index] ?? null : null;
  });
  public readonly laatste = computed(() => this.index() >= this.aantal() - 1);

  public start(workflow: OnboardingWorkflow): void {
    const stappen = RONDLEIDINGEN[workflow];
    if (!stappen?.length) {
      return;
    }
    this.lopend.set({ workflow, stappen, index: 0 });
  }

  /** "Next", of "Done" bij de laatste stap: dan telt de workflow als klaar. */
  public volgende(): void {
    const r = this.lopend();
    if (!r) {
      return;
    }
    if (r.index < r.stappen.length - 1) {
      this.lopend.set({ ...r, index: r.index + 1 });
      return;
    }
    this.lopend.set(null);
    this.onboarding.klaar(r.workflow).subscribe({ error: () => undefined });
  }

  /** "Skip tour" of Escape: stoppen zonder iets te bewaren. */
  public overslaan(): void {
    this.lopend.set(null);
  }
}
